import React, { useMemo } from "react";
import profileImg from "assets/images/adam.jpg";
import rightIcon from "assets/images/right.svg";
import FormField from "./FormField";
import ProgressBar from "./ProgressBar";

const FormStepContent = ({
  stepIndex,
  stepsLength,
  currentStep,
  selectedOption,
  setSelectedOption,
  textGridValues,
  setTextGridValues,
  validationErrors,
  handleNext,
  onFinish,
  isNextDisabled,
  creditors,
  onFieldBlur, // blur handler passed here
}) => {
  const progressPercentage = useMemo(
    () => ((stepIndex + 1) / stepsLength) * 100,
    [stepIndex, stepsLength]
  );

  const getButtonLabel = () => {
    if (stepIndex === stepsLength - 2) return "Get My Quote";
    if (stepIndex < 1) return "LET’S GO";
    return "NEXT";
  };

  const renderStepContent = () => {
    switch (currentStep.type) {
      case "radio":
        return (
          <div className="options">
            {currentStep.options.map((option) => (
              <FormField
                key={option}
                field={option}
                typeOverride="radio"
                checked={selectedOption === option}
                onChange={() => setSelectedOption(option)}
                name={`step-${stepIndex}`}
              />
            ))}
            {validationErrors.general && (
              <div className="error-text">{validationErrors.general}</div>
            )}
          </div>
        );

      case "text-grid":
      case "text-area":
        return (
          <div className="user_from__text-grid">
            {currentStep.fields.map((field) => {
              const label = typeof field === "string" ? field : field.label;
              const type =
                currentStep.type === "text-area"
                  ? "textarea"
                  : typeof field === "string"
                  ? "text"
                  : field.type || "text";

              return (
                <FormField
                  key={label}
                  field={field}
                  value={textGridValues[label] || ""}
                  onChange={(val) =>
                    setTextGridValues({ ...textGridValues, [label]: val })
                  }
                  onBlur={() => onFieldBlur(label)} // Pass label to blur handler
                  error={validationErrors[label]}
                  typeOverride={type}
                  required={field.required}
                  validate={field.validate}
                  creditors={creditors}
                />
              );
            })}
          </div>
        );

      case "lastScreen":
        return <ProgressBar onFinish={onFinish} />;

      default:
        return <div />;
    }
  };

  return (
    <div className="user_from__content">
      <img src={profileImg} alt="Profile" className="profile-img" />

      {stepIndex !== stepsLength - 1 && (
        <div className="progress-bar">
          <div className="filled" style={{ width: `${progressPercentage}%` }} />
        </div>
      )}

      <h2>{currentStep.heading}</h2>

      {renderStepContent()}

      {stepIndex !== stepsLength - 1 && (
        <button
          className="next-btn"
          onClick={handleNext}
          disabled={isNextDisabled}
        >
          <span className="next-label">{getButtonLabel()}</span>
          {stepIndex !== stepsLength - 2 && (
            <img src={rightIcon} alt="Right Arrow" className="next-icon" />
          )}
        </button>
      )}

      {stepIndex === stepsLength - 2 && (
        <div className="terms_text">
          By clicking “Get My Quote” I understand that The Fullman Firm, a
          California law firm, may refer my inquiry to CollectionDefense.com, a
          non-lawyer document preparation service. The owners of The Fullman
          Firm also have a financial interest in CollectionDefense.com. This
          referral complies with the California Rules of Professional Conduct,
          including Rules 1.7 and 5.4. I consent to be contacted.
        </div>
      )}
    </div>
  );
};

export default FormStepContent;
